import useOnClickOutside from '@/hooks/useOnClickOutside';
import { RefObject, useState } from 'react';

export const useMenuToggle = (ref: RefObject<HTMLElement>) => {
	const [isMenuOpening, setIsMenuOpening] = useState(false);
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	useOnClickOutside({
		ref,
		handler: () => setIsMenuOpen(false)
	});

	const handleMenuToggle = () => {
		setIsMenuOpening(true);

		setTimeout(() => {
			setIsMenuOpen(prev => !prev);
			setIsMenuOpening(false);
		}, 300);
	};

	return { isMenuOpening, isMenuOpen, handleMenuToggle };
};
